import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.number.parse-int.js";
import "core-js/modules/es6.number.constructor.js";
export var sortItemsByNodePath = function sortItemsByNodePath(itemsWithPath) {
  if (!Array.isArray(itemsWithPath)) throw new Error('itemsWithPath must be an array');
  var sortable = itemsWithPath.map(function (item) {
    return {
      // Pull out a number array for the indexes in the path
      // The key for:
      //    props.children.50.props.children.0.props.children.10.props.children.1
      // Would be:
      //    [50,0,10,1]
      key: !item.nodePath ? [] : _toConsumableArray(item.nodePath.matchAll(/\d+/g)).map(function (i) {
        return Number.parseInt(i[0], 10);
      }),
      item: item
    };
  });
  var sorted = sortable.sort(function (a, b) {
    var keyA = a.key;
    var keyB = b.key;
    var longerLength = Math.max(keyA.length, keyB.length);

    for (var i = 0; i < longerLength; i += 1) {
      if (keyA[i] !== keyB[i]) {
        if (typeof keyA[i] === 'undefined') return -1;
        if (typeof keyB[i] === 'undefined') return 1;
        return keyA[i] > keyB[i] ? 1 : -1;
      }
    }

    return 0;
  }).map(function (i) {
    return i.item;
  });
  return sorted;
};